module.exports = __webpack_public_path__ + "static/media/edit-blue-icon.7024c158.svg";